import * as React from 'react'
import { Route, Switch } from 'react-router-dom'
import LocationPane from '../../../containers/riders/createrider/LocationPane'
import MembershipPane from '../../../containers/riders/createrider/MembershipPane'
import WalletPane from '../../../containers/riders/createrider/WalletPane'
import { IOrganizationsMetadata, IRiderObject, IStateMetadata, StateOrganizationMap } from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import RiderProfileCreateStepSelector from './RiderProfileCreateStepSelector'
import PersonalInfoPane from './personalinfo/PersonalInfoPane'

interface IRiderProfileCreatePaneState {
  currentError: { isError: boolean; message: string }
  currentStep: number
  isRiderSaved: boolean
  steps: boolean[]
}

interface IRiderProfileCreatePaneProps {
  history: any
  match: any
  metadata: IStateMetadata
  organizations: StateOrganizationMap
  organizationsFetchingMetaData: IOrganizationsMetadata
  currentOrgId: string
  rider: IRiderObject
  saveRider: (rider: IRiderObject) => Promise<any>
  getAllAvailableOrganizations: () => void
  clear: () => void
}

class RiderProfileCreatePane extends React.Component<IRiderProfileCreatePaneProps, IRiderProfileCreatePaneState> {
  constructor(props: any) {
    super(props)
    this.state = {
      isRiderSaved: false,
      steps: [false, false, false, false, false, false],
      currentStep: 1,
      currentError: { isError: false, message: '' }
    }
  }

  public componentDidMount() {
    this.props.getAllAvailableOrganizations()
  }

  public componentDidUpdate(prevProps: IRiderProfileCreatePaneProps) {
    if (prevProps.metadata !== this.props.metadata) {
      const { processingError, processingSuccess } = this.props.metadata
      if (processingError) {
        this.showMessage(processingError, true)
        this.props.history.push(`${this.props.match.path}/profile/confirm-phone-number`)
      }
      if (processingSuccess) {
        if (this.props.rider.saved) {
          this.setState({ isRiderSaved: true })
        }
        this.onCompleteStep(this.state.currentStep)
        this.showMessage(processingSuccess, false)
      }
    }
  }

  public componentWillUnmount() {
    this.props.clear()
  }

  public render() {
    const getPersonalInfoPane = (props: any) => {
      return (
        <PersonalInfoPane
          currentStep={1}
          onCompleteStep={this.onCompleteStep}
          showMessage={this.showMessage}
          metadata={this.props.metadata}
          rider={this.props.rider}
          saveRider={this.saveRider}
          currentOrgId={this.props.currentOrgId}
          organizations={this.props.organizations}
          organizationsFetchingMetaData={this.props.organizationsFetchingMetaData}
          match={this.props.match}
          history={this.props.history}
        />
      )
    }
    const getLocationPane = (props: any) => {
      return (
        <LocationPane
          currentStep={2}
          onCompleteStep={this.onCompleteStep}
          showMessage={this.showMessage}
          metadata={this.props.metadata}
          rider={this.props.rider}
        />
      )
    }
    const getMembershipPane = (props: any) => {
      return (
        <MembershipPane
          currentStep={3}
          onCompleteStep={this.onCompleteStep}
          showMessage={this.showMessage}
          metadata={this.props.metadata}
          rider={this.props.rider}
        />
      )
    }
    const getWalletPane = (props: any) => {
      return (
        <WalletPane
          currentStep={4}
          onCompleteStep={this.onCompleteStep}
          showMessage={this.showMessage}
          metadata={this.props.metadata}
          rider={this.props.rider}
        />
      )
    }

    return (
      <section>
        <div>
          {this.state.currentError.message.length > 0 && (
            <div className={'pr1 pl3 pt1 pb1 font-white ' + (this.state.currentError.isError ? 'bg-red' : 'bg-green')}>
              {this.state.currentError.message}
            </div>
          )}
          <div className='form-title-header'>
            <div>
              <span className='h3'>{UIMessages.common.createNewRider}</span>
              <span className='ml2 h6 font-light-blue-grey'>Step {this.state.currentStep} of 4</span>
            </div>
          </div>
          <div>
            <RiderProfileCreateStepSelector
              isStepComplete={this.isStepComplete}
              isRiderSaved={this.state.isRiderSaved}
              path={this.props.match.path}
              pathname={location.pathname}
            />
          </div>
          <Switch>
            <Route
              onChange={this.onRouteChange()}
              path={`${this.props.match.path}/profile`}
              render={getPersonalInfoPane}
            />
            <Route
              onChange={this.onRouteChange()}
              path={`${this.props.match.path}/location`}
              render={getLocationPane}
            />
            <Route
              onChange={this.onRouteChange()}
              path={`${this.props.match.path}/membership`}
              render={getMembershipPane}
            />
            <Route onChange={this.onRouteChange()} path={`${this.props.match.path}/wallet`} render={getWalletPane} />
          </Switch>
        </div>
      </section>
    )
  }

  private onRouteChange = () => {
    if (/\/info/.test(location.pathname) && this.state.currentStep !== 1) {
      this.setState({
        currentStep: 1,
        currentError: { message: '', isError: false }
      })
    }
    if (/\/location/.test(location.pathname) && this.state.currentStep !== 2) {
      this.setState({
        currentStep: 2,
        currentError: { message: '', isError: false }
      })
    }
    if (/\/membership/.test(location.pathname) && this.state.currentStep !== 3) {
      this.setState({
        currentStep: 3,
        currentError: { message: '', isError: false }
      })
    }
    if (/\/wallet/.test(location.pathname) && this.state.currentStep !== 4) {
      this.setState({
        currentStep: 4,
        currentError: { message: '', isError: false }
      })
    }
  }

  private showMessage = (message: string, isError: boolean) => {
    if (this.state.currentError.message === message) {
      return
    }
    this.setState({ currentError: { message, isError } })
  }

  private onCompleteStep = (step: number) => {
    if (step < 1 || step > 6) {
      return
    }
    const steps = Object.assign([] as boolean[], this.state.steps)
    steps[step - 1] = true
    this.setState({ steps })
  }

  private isStepComplete = (step: number) => {
    return step < 1 || step > 6 ? false : this.state.steps[step - 1]
  }

  private saveRider = (rider: IRiderObject) => {
    return this.props.saveRider(rider)
  }
}
// repushing for phone number validation changes
export default RiderProfileCreatePane



// WEBPACK FOOTER //
// ./src/components/riders/createrider/RiderProfileCreatePane.tsx